import { createFileRoute, redirect } from "@tanstack/react-router";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/de/dealeri/")({
  head: () => routeHead("/de/dealeri/"),
  beforeLoad: () => {
    throw redirect({ href: "/de/verified-dealers", statusCode: 301, replace: true });
  },
});
